import React from 'react';
import './FaceRecognition.css';

const FaceRecognition = ({ imageUrl, boxes }) => {
	return (
		<div className='center ma'>
		<div className='absolute mt2'>
			<img id='inputimage' alt='' src={imageUrl} width='500px' height='auto'/>
			{boxes.map((currentBox, index) => (
				<div key={index} className='bounding-box' style={
					{
						top: currentBox.topRow, 
						right: currentBox.rightCol, 
						bottom: currentBox.bottomRow, 
						left: currentBox.leftCol
					}}
					></div>
			))}
		
		</div>
		</div>
	);
}

export default FaceRecognition;